module.exports = __webpack_public_path__ + "img/2-7-las-vegas-strip.b390cc65.jpg";